import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { getEntityIdUrlSearch } from '../chartsUtils';
import { EntityType } from '../../entity.types';
import { getPageName } from '../../../utils/pageName';
import { openNewTab } from '../../../utils/domUtils';

export const juridictionBaseH = 25;

export function buildJurisdictionUrl({
  entityName,
  entityType,
  entityIdUrlArg,
  juridictionKey,
}: {
  entityName: string;
  entityType: EntityType;
  entityIdUrlArg: string;
  juridictionKey: string;
}) {
  return buildUrlWithParameters('/search', {
    q: encodeURIComponent(entityName),
    [getEntityIdUrlSearch(entityType)]: entityIdUrlArg,
    juridiction: encodeURIComponent(`["${juridictionKey}"]`),
    chrono: true,
    sourcePage: getPageName(),
  });
}

export function juridictionClicked({
  juridictionKey,
  entityName,
  entityIdUrlArg,
  entityType,
  metaKey,
}: {
  juridictionKey: string;
  entityName: string;
  entityIdUrlArg: string;
  entityType: EntityType;
  metaKey: boolean;
}) {
  const url = buildJurisdictionUrl({
    entityName,
    entityType,
    entityIdUrlArg,
    juridictionKey,
  });

  if (metaKey) {
    openNewTab(url);
  } else {
    window.location.href = url;
  }
}
